import { createReducer } from '@reduxjs/toolkit';
import { CurveManagerDialogs, } from '@innovyze/stylovyze/lib/types/curveManager.types';
import { bulkAction, bulkActionRejected, bulkActionResolved, checkDuplicateCurveById, checkDuplicateCurveByIdRejected, checkDuplicateCurveByIdResolved, closeDeleteModal, closeDialog, closeOverwriteModal, getCurves, getCurvesRejected, getCurvesResolved, openDeleteModal, openDialog, openOverwriteModal, setCurveData, tableAction, } from '@innovyze/stylovyze/lib/actions/curveManager.actions';
export const initialState = {
    dialog: undefined,
    deleteModal: {
        open: false,
        curveId: '',
    },
    overwriteModal: {
        open: false,
        initialized: false,
    },
    curveById: {
        curve: undefined,
        initialized: false,
    },
    paginatedCurveList: {
        initialized: false,
        assets: [],
        pagination: {
            total: 0,
            previous: 0,
            next: 0,
            current: 0,
            pages: 0,
        },
        tableState: {
            limitIndex: 1,
            searchQuery: '',
            page: 1,
        },
    },
    bulkCurveActionResult: {
        status: 'not_initialized',
    },
};
const reducer = {
    [openDialog.toString()]: (state, action) => {
        const payloadAction = action;
        const payloadCurve = payloadAction.payload;
        let newCurve, newDialog;
        if (payloadCurve) {
            newDialog = CurveManagerDialogs.EditCurve;
            newCurve = state.curveById.curve
                ? {
                    ...state.curveById.curve,
                    ...payloadCurve,
                }
                : {
                    _id: payloadCurve._id ?? '',
                    name: payloadCurve.name ?? '',
                    assetType: payloadCurve.assetType ?? '',
                    curveId: payloadCurve.curveId ?? '',
                    assetId: payloadCurve.assetId ?? '',
                    depthArray: payloadCurve.depthArray ?? [],
                    volumeArray: payloadCurve.volumeArray ?? [],
                    xSeries: payloadCurve.xSeries,
                    ySeries: payloadCurve.ySeries,
                    oldAssetType: payloadCurve.oldAssetType,
                };
        }
        else {
            newDialog = CurveManagerDialogs.CreateCurve;
            newCurve = state.curveById.curve;
        }
        return {
            ...state,
            dialog: newDialog,
            curveById: {
                curve: newCurve,
                initialized: true,
                error: undefined,
            },
        };
    },
    [closeDialog.toString()]: state => ({
        ...state,
        curveById: {
            curve: undefined,
            error: undefined,
            initialized: true,
        },
        dialog: undefined,
    }),
    [openDeleteModal.toString()]: (state, { payload }) => ({
        ...state,
        deleteModal: {
            open: true,
            curveId: payload,
        },
    }),
    [closeDeleteModal.toString()]: state => ({
        ...state,
        deleteModal: {
            open: false,
            curveId: '',
        },
    }),
    [openOverwriteModal.toString()]: (state, { payload }) => ({
        ...state,
        overwriteModal: {
            ...state.overwriteModal,
            open: true,
            curveType: payload,
        },
    }),
    [closeOverwriteModal.toString()]: state => ({
        ...state,
        overwriteModal: {
            curveById: undefined,
            curveType: undefined,
            open: false,
            initialized: false,
        },
    }),
    [setCurveData.toString()]: (state, { payload }) => ({
        ...state,
        curveById: {
            curve: payload,
            initialized: true,
            error: undefined,
        },
    }),
    [getCurves.toString()]: state => ({
        ...state,
        paginatedCurveList: {
            ...state.paginatedCurveList,
            initialized: false,
        },
    }),
    [getCurvesResolved.toString()]: (state, action) => ({
        ...state,
        paginatedCurveList: {
            ...state.paginatedCurveList,
            assets: action.payload.assets,
            pagination: action.payload.pagination,
            initialized: true,
        },
    }),
    [getCurvesRejected.toString()]: state => ({
        ...state,
        paginatedCurveList: {
            ...state.paginatedCurveList,
            initialized: true,
        },
    }),
    [checkDuplicateCurveById.toString()]: state => ({
        ...state,
        overwriteModal: {
            ...state.overwriteModal,
            curveById: undefined,
            initialized: false,
            error: undefined,
        },
    }),
    [checkDuplicateCurveByIdResolved.toString()]: (state, { payload }) => ({
        ...state,
        overwriteModal: {
            ...state.overwriteModal,
            curveById: payload,
            initialized: true,
            error: undefined,
        },
    }),
    [checkDuplicateCurveByIdRejected.toString()]: (state, { payload }) => ({
        ...state,
        overwriteModal: {
            ...state.overwriteModal,
            curveById: undefined,
            initialized: false,
            error: payload,
        },
    }),
    [bulkAction.toString()]: state => ({
        ...state,
        bulkCurveActionResult: {
            ...state.bulkCurveActionResult,
            status: 'processing',
        },
    }),
    [bulkActionResolved.toString()]: (state, { payload }) => ({
        ...state,
        bulkCurveActionResult: {
            response: payload,
            status: payload.errors
                ? 'error'
                : 'success',
        },
    }),
    [bulkActionRejected.toString()]: state => ({
        ...state,
        bulkCurveActionResult: {
            response: {
                items: [],
                errors: true,
            },
            status: 'error',
        },
    }),
    [tableAction.toString()]: (state, { payload }) => ({
        ...state,
        paginatedCurveList: {
            ...state.paginatedCurveList,
            tableState: {
                limitIndex: payload.limitIndex,
                searchQuery: payload.searchQuery,
                page: payload.page,
            },
        },
    }),
};
export default createReducer(initialState, reducer);
